import { TYRE_IDENTIFIER_FIELD } from '@wyz/types';
import { TranslationKeys } from '~/common/types';

export const TYRE_IDENTIFIER_FIELD_LABEL: Record<
  string,
  keyof TranslationKeys
> = {
  [TYRE_IDENTIFIER_FIELD.CAI]: 'app.common.displayable_identifier.cai',
  [TYRE_IDENTIFIER_FIELD.CONSTRUCTOR_REFERENCE]:
    'app.common.displayable_identifier.constructor_reference',
  [TYRE_IDENTIFIER_FIELD.WYZ_REFERENCE]:
    'app.common.displayable_identifier.wyz_reference',
};
